import { X } from "lucide-react";

const VideoModal = ({ videoUrl, onClose }) => {
    if (!videoUrl) return null;

    const getYouTubeId = (url) => {
        if (!url) return null;
        const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([^?&]+)/);
        return match ? match[1] : null;
    };

    const videoId = getYouTubeId(videoUrl);
    if (!videoId) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm" onClick={onClose}>
            <div className="relative w-full max-w-4xl mx-4" onClick={e => e.stopPropagation()}>
                <button onClick={onClose} className="absolute -top-12 right-0 text-white hover:text-gray-300 transition">
                    <X size={28} />
                </button>
                <div className="relative pt-[56.25%] rounded-2xl overflow-hidden shadow-2xl">
                    <iframe
                        className="absolute inset-0 w-full h-full"
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                        title="Video"
                        allow="autoplay; encrypted-media; fullscreen"
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    );
};

export default VideoModal;
